import React, { useContext } from 'react';

import { Color, ColorBorderLight, ColorVariantsLight } from '@/constants/color';
import usePersonTags from '@/hooks/usePersonTags';
import PersonContext from '@/pages/Person/PersonContext';
import { Pill, Typography } from '@/ui';
import TagsEditor from '@/ui/components/TagsEditor';

import type { Props } from './types';

const PersonTags = ({ allowEdit = true }: Props) => {
  const { person } = useContext(PersonContext);
  const { data, isError } = usePersonTags({
    enabled: !allowEdit,
    personId: person.id
  });

  // The dugout person payload carries tag names only, so the colors come from
  // the same endpoint the editor loads.
  const tags = data?.tags ?? [];

  return (
    <div className="mt-2">
      {allowEdit ? (
        <TagsEditor contentType="people" />
      ) : isError ? (
        <Typography className="text-uniform-red-600 dark:text-uniform-red-500">
          Unable to load tags.
        </Typography>
      ) : (
        <div className="flex flex-row flex-wrap items-center gap-1">
          {tags.map((tag) => {
            const color: Color = (tag.color as Color) || Color.GRAY;

            return (
              <Pill
                className={`${ColorVariantsLight[color]} ${ColorBorderLight[color]}`}
                key={tag.slug}
                size="sm"
                variant="subtle">
                {tag.name}
              </Pill>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default React.memo(PersonTags);
